// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bh-2";
export var aiChatCartContainerExit = "_bh-4";
export var aiChatContainerLarge = "_bh-0";
export var aiChatContainerSmall = "_bh-1";
export var aiChatIcon = "_bh-6";
export var slideInFromRight = "_bh-3";
export var slideOutToRight = "_bh-5";